/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currency_CzkInputs */

const cs_currency_czk = /** @type {(inputs: Currency_CzkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CZK — česká koruna`)
};

const en_currency_czk = /** @type {(inputs: Currency_CzkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CZK — Czech koruna`)
};

/**
* | output |
* | --- |
* | "CZK — Czech koruna" |
*
* @param {Currency_CzkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const currency_czk = /** @type {((inputs?: Currency_CzkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currency_CzkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_currency_czk(inputs)
	return cs_currency_czk(inputs)
});